/** @format */

import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { signIn } from "../redux/slices/userSlice";
import { useSearchParams } from "react-router-dom";

export default function Login() {
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [incorrect, setIncorrect] = useState("");
  const dispatch = useDispatch();
  const path = useSelector((state) => state.sitePath);

  useEffect(() => {
    setIncorrect("");
  }, [username, password]);

  const signin = (e) => {
    e.preventDefault();
    const obj = {
      username: username,
      password: password,
    };
    axios
      .post(path + "/post.php", obj)
      .then((res) => {
        if (res.data === "El usuario o contraseña son incorrectos.") {
          setIncorrect(res.data);
        } else {
          const user = res.data[0].mail;
          const pass = res.data[0].password;
          const id = res.data[0].id;
          const email = res.data[0].mail;
          dispatch(signIn({ user, pass, id, email }));
        }
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  function handleChangeUser(event) {
    setUserName(event.target.value);
  }
  function handleChangePassword(event) {
    setPassword(event.target.value);
  }

  return (
    <div className=' login d-flex justify-content-center align-items-center vh-100'>
      <div className='container w-100 d-flex justify-content-center'>
        <div
          className='border rounded p-4 shadow container-login'
          style={{ maxWidth: "500px", width: "100%" }}
        >
          {/* <div className='text-center mb-4'>
            <img
              src='https://fundacionunam.org/cei/mi_cei/img/logo_funam.png'
              alt='Logo'
              className='img-fluid w-50 h-50'
            />
          </div> */}
          <div className='text-center mb-4'>
            <img
              src='https://fundacionunam.org/cei/mi_cei/img/logo_cei_general_Mesa%20de%20trabajo%201.png'
              alt='Logo'
              className='img-fluid'
            />
          </div>

          <h2 className='text-center mb-4'>Inicia sesión</h2>
          <form onSubmit={signin}>
            <div className='mb-3'>
              <label className='form-label'>Usuario</label>
              <input
                type='text'
                className='form-control'
                onChange={handleChangeUser}
              />
            </div>

            <div className='mb-3'>
              <label className='form-label'>Contraseña</label>
              <input
                type='password'
                className='form-control'
                onChange={handleChangePassword}
              />
              {incorrect && <div className='text-danger mt-2'>{incorrect}</div>}
            </div>

            <div className='d-grid'>
              <button
                type='submit'
                className='btn btn-primary'
              >
                Sign in
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
